import AllWhoresPage from "@/views/AllWhoresPage.vue";
import ProfilePage from "@/views/ProfilePage.vue";
import SearchPage from "@/views/SearchPage.vue";
import WhorePage from "@/views/WhorePage.vue";
import { createRouter, createWebHistory } from "vue-router";
import MainPage from "../views/MainPage.vue";
import MiniApp from "@/views/MiniApp.vue";
import TechPage from "@/views/TechPage.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: MainPage,
  },
  {
    path: "/profile",
    name: "profile",
    component: ProfilePage,
  },
  {
    path: "/girl/:id",
    name: "whore",
    component: WhorePage,
  },
  {
    path: "/search/:query/:id",
    name: "search",
    component: SearchPage,
  },
  {
    path: "/girls/:query?/:id",
    name: "girls",
    component: AllWhoresPage,
  },
  {
    path: "/panel/addwhore",
    name: "miniapp",
    component: MiniApp,
  },
  {
    path: "/support",
    component: TechPage,
  },
  {
    path: "/:pathMatch(.*)*", // Захват всех несуществующих маршрутов
    redirect: "/", // Перенаправление на главную страницу
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
